import { AnchorHTMLAttributes, CSSProperties } from 'react';
import { ConditionalWrapper } from 'ui/ConditionalWrapper';
import { StyledIcon } from './style';
export interface IconProps {
  name?: string;
  type?:
    | 'extra-small'
    | 'small'
    | 'medium'
    | 'large'
    | 'card'
    | 'filter-icon'
    | 'avarage'
    | 'header'
    | 'any'
    | 'footerMobile'
    | 'footer'
    | 'cartDrawerClose';
  svg?: boolean;
  style?: CSSProperties;
  onClick?: any;
  url?: AnchorHTMLAttributes<HTMLAnchorElement>;
  className?: string;
}

export const Icon = ({
  name,
  type = 'medium',
  svg = true,
  style,
  onClick,
  url,
  className,
}: IconProps) => {
  return (
    <ConditionalWrapper
      condition={!!url}
      wrapper={(children) => <a {...url}>{children}</a>}
    >
      <StyledIcon type={type} onClick={onClick} className={className}>
        <img
          src={svg ? `/svgs/${name}.svg` : `/${name}`}
          style={style}
          alt={name}
        />
      </StyledIcon>
    </ConditionalWrapper>
  );
};
